import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-message-sidenav",
  templateUrl: "./message-sidenav.component.html",
})
export class MessageSidenavComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
